const translations = {
    es: {
        "show-on-map": "Ver en el mapa",
        "refresh": "Refrescar",
        "coordinates": "Coordenadas",
        "uids": "UIDs",
        "island": "Isla",
        "observations": "Observaciones",
        "copy-coordinates": "Copiar coordenadas",
        "copied": "Copiado",
    },
    en: {
        "show-on-map": "Show on map",
        "refresh": "Refresh",
        "coordinates": "Coordinates",
        "uids": "UIDs",
        "island": "Island",
        "observations": "Observations",
        "copy-coordinates": "Copy coordinates",
        "copied": "Copied",
    },
};

export default translations;
